import { render, staticRenderFns } from "./MemberForm.vue?vue&type=template&id=240fbe85&scoped=true&"
import script from "./MemberForm.vue?vue&type=script&lang=js&"
export * from "./MemberForm.vue?vue&type=script&lang=js&"
import style0 from "./MemberForm.vue?vue&type=style&index=0&id=240fbe85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240fbe85",
  null
  
)

export default component.exports